import { Typography } from '@material-ui/core';
import React, { useState, useEffect } from 'react';
import { useStyles } from './styles';

const DateTime = (props: any) => {
   const [date, setDate] = useState(new Date());
   const classes = useStyles(props);

   useEffect(() => {
      const timer = setInterval(() => setDate(new Date()), 1000);

      return function cleanup() {
         clearInterval(timer);
      };
   });

   return (
      <div className={classes.root}>
         <Typography variant="caption" color={props.color}>
            {date.toLocaleTimeString()}
         </Typography>
      </div>
   );
};

export default DateTime;
